// src/features/COMPANY/page/Category

import DynamicTable from '@/common/components/DynamicTable/DynamicTable';
import type { ColumnsType } from 'antd/es/table';

import { API_ENDPOINTS, QUERY_KEYS } from '../../../../participants/api/apiEndpoints';
import type { ExceptionType } from '../../../../participants/types/ExceptionType';
import StatusTag from '../../../../../common/components/Status';
import { useTranslation } from "react-i18next";

const Exceptions = () => {
    const { t } = useTranslation();
    
    // Define columns for the ServiceItem table
    const ExceptionsColumns: ColumnsType<ExceptionType> = [
        { title: "Company", dataIndex: "companyName", key: "companyName" },
        { title: "ExceptionName", dataIndex: "name", key: "name" },
        { title: t("Service Name"), dataIndex: "serviceCategoryItemName", key: "serviceCategoryItemName" },
        {
            title: t("Type"),
            dataIndex: "serviceCategoryItemId",
            key: "serviceCategoryItemId",
            render: (serviceCategoryItemId: number) => (
                <StatusTag status={serviceCategoryItemId == 0 ? "General" : "Service"} />
            ),
        }
    ];

    return (
        <div>
            <DynamicTable<ExceptionType> // Ensure generic type matches the data
                dataApiUrl={API_ENDPOINTS.EXCEPTIONS.SEARCH} // Your API endpoint for fetching menus
                baseQueryKey={QUERY_KEYS.EXCEPTIONS.EXCEPTIONS} // Unique query key for menus
                columns={ExceptionsColumns}
                tableTitle={t("companyExceptions")}
                showActions={{ delete: true }}
                deleteBaseUrl={API_ENDPOINTS.EXCEPTIONS.DELETE_EXCEPTION}
                deletePayloadField="companyName"   
                // Pass the fields you want the search bar to filter
                filterConfigs={[
                    {
                        field: 'companyId',
                        type: 'select',
                        placeholder: "Select company",
                        showSearch: true,
                        dynamicOptions: {
                            url: "/Lookup/GetDropdownData",
                            method: "POST",
                            body: { "dropdowns": ["company"] },
                            transformData: (apiResponse: unknown) => {
                                const response = apiResponse as { company: { Name: string; Id: number }[] };
                                return response.company.map((item) => ({ label: item.Name, value: item.Id }))
                            }
                        },
                    },
                    { field: "name", placeholder: t("SearchbyName") },
                    {
                        field: "Print",
                        type: "export",
                        exportOptions: {
                            url: API_ENDPOINTS.EXCEPTIONS.EXPORT,
                            fileName: "CompanyException",
                            fileType: "excel", // "csv" 
                            defaultPayload: {},
                            columns: [
                                { header: "Company", key: "companyName" },
                                { header: "Name", key: "name" },
                                { header: "Service", key: "serviceCategoryItemName" },
                                { header: "Type", key: "serviceCategoryItemId", transform: (val: number) => val === 0 ? "General" : "Service" },
                            ]
                        }
                    }
                ]}
            />
        </div>
    );
};

export default Exceptions;